// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.profile__basic-info {
    margin-top: 16px;
    border-radius: 14px;
}

.profile-basic-info .hubicon-edit {
    font-size: 24px;
}

.profile-basic-info__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 24px;
    padding: 0;
}

.profile-basic-info__content__country-img {
    display: flex;
    gap: 9px;
    align-items: center;
    white-space: nowrap;
}

.profile-basic-info__content__country-img p{
    text-transform: lowercase;
}

.profile-basic-info__content__country-img span{
    text-transform: none;
}

.profile-basic-info__content__country-img p::first-letter {
    text-transform: uppercase;
}

.profile-basic-info__content__country-img img {
    width: 23px;
    height: 23px;
    border-radius: 50%;
}

.profile-basic-info__content-col {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.profile-basic-info__content-col .baloa-subtitle-2 {
    color: var(--primary-dark-color);
}

.profile-basic-info__content-col .baloa-normal-medium {
    color: var(--basic-gray-color);
    margin-top: 8px;
}

.profile-basic-info__content__country-img .icon-ball {
    color: var( --white-color );
    font-size: 16px;
    border-radius: 50%;
    padding: 4px;    
}

.profile-basic-info__content__weight-label,
.profile-basic-info__content__height-label {
    display: flex;
    align-items: center;
    gap: 4px;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .profile-basic-info__content {
        padding: 0;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .profile-basic-info__content__country-img img {
        width: 17px;
        height: 17px;
        border-radius: 50%;
    }    

    .profile__basic-info {
        margin-left: 10px;
        margin-right: 10px;
        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.12);
    }

    .profile-basic-info__content-col {
        width: 30%;
        margin-bottom: 24px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/profiles/components/profile-basic-info/ProfileBasicInfoComponent.style.css"],"names":[],"mappings":";AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,UAAU;QACV,eAAe;QACf,6BAA6B;IACjC;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,2CAA2C;IAC/C;;IAEA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ","sourcesContent":["\n.profile__basic-info {\n    margin-top: 16px;\n    border-radius: 14px;\n}\n\n.profile-basic-info .hubicon-edit {\n    font-size: 24px;\n}\n\n.profile-basic-info__content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 24px;\n    padding: 0;\n}\n\n.profile-basic-info__content__country-img {\n    display: flex;\n    gap: 9px;\n    align-items: center;\n    white-space: nowrap;\n}\n\n.profile-basic-info__content__country-img p{\n    text-transform: lowercase;\n}\n\n.profile-basic-info__content__country-img span{\n    text-transform: none;\n}\n\n.profile-basic-info__content__country-img p::first-letter {\n    text-transform: uppercase;\n}\n\n.profile-basic-info__content__country-img img {\n    width: 23px;\n    height: 23px;\n    border-radius: 50%;\n}\n\n.profile-basic-info__content-col {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.profile-basic-info__content-col .baloa-subtitle-2 {\n    color: var(--primary-dark-color);\n}\n\n.profile-basic-info__content-col .baloa-normal-medium {\n    color: var(--basic-gray-color);\n    margin-top: 8px;\n}\n\n.profile-basic-info__content__country-img .icon-ball {\n    color: var( --white-color );\n    font-size: 16px;\n    border-radius: 50%;\n    padding: 4px;    \n}\n\n.profile-basic-info__content__weight-label,\n.profile-basic-info__content__height-label {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .profile-basic-info__content {\n        padding: 0;\n        flex-wrap: wrap;\n        justify-content: space-around;\n    }\n\n    .profile-basic-info__content__country-img img {\n        width: 17px;\n        height: 17px;\n        border-radius: 50%;\n    }    \n\n    .profile__basic-info {\n        margin-left: 10px;\n        margin-right: 10px;\n        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.12);\n    }\n\n    .profile-basic-info__content-col {\n        width: 30%;\n        margin-bottom: 24px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
